// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MajorWishList/OperationBtn.less
// module id = 927
// module chunks = 0